import React, { Component } from 'react';
import {loadCsrf} from './../common/CsrfFetcher';
import {Modal} from 'react-bootstrap';
import JoinOrganizationPendingModal from './JoinOrganizationPendingModal';

class SelectOrgToJoinModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orgToJoinCandidateNames: [],
			selectedOrgToJoin:"",
			selectedOrgNameToJoin:"",
			csrfToken:'',
			showJoinOrganizationPendingModal: false,
			pendingRequestOrgName:""
		};
	}

	validateForm = () => {
		 const joinOrgForm = this.joinOrgForm;
		 const formLength = joinOrgForm.length;
		 for (let i = 0; i < formLength; i++) {
			const elem = joinOrgForm[i];
			if(elem.value === "")	{
				return false;
			}
		 }
		 return true;
	}

	componentDidMount() {
		loadCsrf(this.setCsrfState);
	}

	setCsrfState = (csrfToken, csrfHeaderValue) => {
		var state = this.state;
		state.csrfToken = csrfToken;
		this.csrfHeaderValue = csrfHeaderValue;
		this.setState({
			state
		});
	}

	validateResponse = (response) => {
		if (!response.ok) {
			throw Error(response.statusText);
		}
		return response;
	}

	logResult = (result) => {
		console.log('I love this result .... \n\n\n', result);
	}

	handleOrgNameSelectionChange = (event) => {
		var selectedIndex = event.target.selectedIndex;
		var selectedOrgId = event.target.options[selectedIndex].value;
		var selectedOrgName = event.target.options[selectedIndex].innerHTML;
		this.setState({
			selectedOrgToJoin: selectedOrgId,
			selectedOrgNameToJoin: selectedOrgName
		});
	}

	handleOrgJoin = (event) => {
		if(this.validateForm())	{
			this.getUserJoinRequestStatus();
		}
	}

	setOptionsForJoinToOrgCandidates = (event) => {
		let orgToJoinCandidateNames = this.props.orgSearchResults.map((org) =>
                <option key={org.organizationId} value={org.organizationId}>{org.name}</option>
		);
		this.setState({
			orgToJoinCandidateNames: orgToJoinCandidateNames
		});
	}

	hideJoinOrganizationPendingModal = (event) => {
		this.setState({
			showJoinOrganizationPendingModal: false
		});
	}

	getUserJoinRequestStatus = () => {
		console.log('getUserJoinRequestStatus ' + this.state.selectedOrgToJoin);
		console.log('url is ' + process.env.REACT_APP_HOST_API_URL);
		var jsonData = null;
		fetch(process.env.REACT_APP_HOST_API_URL  +  '/developer/mvc/organization/join/pendingJoinRequestStatus' , {
				method: 'get',
				headers: {
					'Accept': 'application/json',
		            'Content-Type': 'application/json'
				},
				credentials: 'include'
			})

			.then(results => {
				this.validateResponse(results);
				this.logResult(results);
				return results.json();
			})
			.catch(error => {
				console.log('error trying to fetch orgs : \n', error);
				return Promise.reject()
			})
			.then(data => {

				console.log(data);
				if(data.userJoinRequestStatus === 'PENDING')	{
					//show the join pending modal
					this.props.hideSelectOrgToJoinModal();
					this.setState({
						showJoinOrganizationPendingModal: true,
						pendingRequestOrgName: data.pendingRequestOrgName
					});
					console.log("userJoinRequestStatus " + data.userJoinRequestStatus);
				} else{
					this.sendRequestToJoinOrg();
				}
				return jsonData;
			});
	}

	sendRequestToJoinOrg = () => {
		this.setState({
			showJoinOrganizationPendingModal: false
		});
		console.log('sending request to join org ' + this.state.selectedOrgToJoin);
		console.log('csrf token ' + this.state.csrfToken);
		console.log('url is ' + process.env.REACT_APP_HOST_API_URL);
		var jsonData = null;
		fetch(process.env.REACT_APP_HOST_API_URL  +  '/developer/mvc/organization/join?orgId=' + this.state.selectedOrgToJoin , {
				method: 'post',
				headers: {
					'Accept': 'application/json',
		            'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.state.csrfToken
				},
				credentials: 'include'
			})

			.then(results => {
				this.validateResponse(results);
				this.logResult(results);
				return results.json();
			})
			.catch(error => {
				console.log('error trying to fetch orgs : \n', error);
				return Promise.reject()
			})
			.then(data => {

				console.log(data);
				this.props.handleResponseForOrgJoinRequest(data);
				return jsonData;
			});
	}

	render () {


		return (
			<div>
				<Modal onHide={this.props.hideSelectOrgToJoinModal} show={this.props.showSelectOrgToJoinModal} onEnter={this.setOptionsForJoinToOrgCandidates} aria-labelledby="ModalHeader">
					<Modal.Header closeButton>
						<Modal.Title id='ModalHeader'>Do you want to join an existing Organization/Company?</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="description-text form-group">
							The organization/company name that you provided is similar to one or more of our
							existing registered organizations/companies. You can join an existing
							organization/company or you can create your own organization/company by clicking
							"Cancel" and continue to fill out your organization/company info on the
							organization/company form.
						</div>
						<div className="form-group">
							<h3 className="text-bold form-heading">Organization/Company Match</h3>
							<p className="text-orange">Our results found one or more similar matches. Please select an organization/company or click "Cancel" to create your own organization/company.</p>
						</div>
						<form id="joinOrgForm" className="customForm" ref={form => (this.joinOrgForm = form)}>
							<select required className="form-control" onChange={this.handleOrgNameSelectionChange} aria-required="true" name="joinOrgCandidates">
								<option value="">Select</option>
								{this.state.orgToJoinCandidateNames}
						</select>
						</form>
					</Modal.Body>
					<Modal.Footer>
						<button className='btn btn-primary' onClick={this.handleOrgJoin} name="Join">
							Join
						</button>
						<button className='btn btn-secondary' onClick={this.props.hideSelectOrgToJoinModal} name="Cancel">
							Cancel
						</button>
					</Modal.Footer>
			</Modal>
			<JoinOrganizationPendingModal showJoinOrganizationPendingModal={this.state.showJoinOrganizationPendingModal}
										  hideJoinOrganizationPendingModal={this.hideJoinOrganizationPendingModal} sendRequestToJoinOrg={this.sendRequestToJoinOrg}
										  pendingRequestOrgName={this.state.pendingRequestOrgName} selectedOrgToJoin={this.state.selectedOrgNameToJoin}/>
		  </div>
		)
	}
}

export default SelectOrgToJoinModal;



// WEBPACK FOOTER //
// ./src/manageOrg/SelectOrgToJoinModal.js